import {
  Directive, ElementRef,
  Input, OnDestroy, OnInit, Host, HostBinding
} from '@angular/core';
import { ComponentLoaderFactory, PopoverConfig, PopoverDirective } from 'ngx-bootstrap';
import { NgxBootstrapProductTourService } from './ngx-bootstrap-product-tour.service';
import { IStep } from './ngx-bootstrap-product-tour.models';
import { NgxBootstrapProductTourStepService } from './ngx-bootstrap-product-tour-step/ngx-bootstrap-product-tour-step.service';
import { Router } from '@angular/router';
export class NgxBootstrapPopoverDirective extends PopoverDirective {
  triggers = '';
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tourAnchor]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxBootstrapPopoverDirective_tsickle_Closure_declarations() {
/** @type {?} */
NgxBootstrapPopoverDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxBootstrapPopoverDirective.ctorParameters;
/** @type {?} */
NgxBootstrapPopoverDirective.prototype.triggers;
}

export class NgxBootstrapProductTourDirective implements OnInit, OnDestroy {
  protected _elementClass: string[] = [];
public tourAnchor: string;
private backdropClass: boolean;
/**
 * @param {?} tourService
 * @param {?} tourStepTemplate
 * @param {?} element
 * @param {?} popoverDirective
 */
constructor(private tourService: NgxBootstrapProductTourService,
private tourStepTemplate: NgxBootstrapProductTourStepService,
private element: ElementRef,
public popoverDirective: NgxBootstrapPopoverDirective,
  ) { }
/**
 * @return {?}
 */
public ngOnInit(): void {
    this.tourService.register(this.tourAnchor, this);
  }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
    this.tourService.unregister(this.tourAnchor);
  }
/**
 * @param {?} step
 * @return {?}
 */
public showTourStep(step: IStep): void {
    this.popoverDirective.popover = this.tourStepTemplate.template;
    this.popoverDirective.popoverTitle = step.title;
    this.popoverDirective.containerClass = step.containerClass ? step.containerClass : '';
    this.popoverDirective.placement = step.placement ? step.placement : 'top';
    this.popoverDirective.container = 'body';
    this.popoverDirective.triggers = '';
    if (step.orphan) {
      this.popoverDirective.containerClass += ' orphan';
    }

    if (step.backdrop && !step.orphan) {
      this.backdropClass = true;
    }
    this.popoverDirective.show();
    if (!step.preventScrolling) {
      ( /** @type {?} */((<HTMLElement>this.element.nativeElement))).scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
    }
  }
/**
 * @return {?}
 */
public hideTourStep(): void {
    this.backdropClass = false;
    this.popoverDirective.hide();
  }
/**
 * @return {?}
 */
public isOpen(): boolean {
    return this.popoverDirective.isOpen;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tourAnchor]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgxBootstrapProductTourService, },
{type: NgxBootstrapProductTourStepService, },
{type: ElementRef, },
{type: NgxBootstrapPopoverDirective, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tourAnchor': [{ type: Input },],
'backdropClass': [{ type: HostBinding, args: ['class.tour-step-backdrop', ] },],
};
}

function NgxBootstrapProductTourDirective_tsickle_Closure_declarations() {
/** @type {?} */
NgxBootstrapProductTourDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxBootstrapProductTourDirective.ctorParameters;
/** @type {?} */
NgxBootstrapProductTourDirective.propDecorators;
/** @type {?} */
NgxBootstrapProductTourDirective.prototype._elementClass;
/** @type {?} */
NgxBootstrapProductTourDirective.prototype.tourAnchor;
/** @type {?} */
NgxBootstrapProductTourDirective.prototype.backdropClass;
/** @type {?} */
NgxBootstrapProductTourDirective.prototype.tourService;
/** @type {?} */
NgxBootstrapProductTourDirective.prototype.tourStepTemplate;
/** @type {?} */
NgxBootstrapProductTourDirective.prototype.element;
/** @type {?} */
NgxBootstrapProductTourDirective.prototype.popoverDirective;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
